function applyTruncationToTitles(containerSelector, titleSelector) {
  const productGrids = document.querySelectorAll(containerSelector);

  productGrids.forEach(grid => {
    const titles = grid.querySelectorAll(titleSelector);

    titles.forEach(title => {
      title.classList.remove('truncate-2-lines');
      title.style.height = 'auto';
    });

    titles.forEach(title => {
      const lineHeight = parseFloat(getComputedStyle(title).lineHeight);
      const lineCount = Math.round(title.scrollHeight / lineHeight);

      if (lineCount > 2) {
        title.classList.add('truncate-2-lines');
        title.style.height = `${lineHeight * 2}px`;
      } else {
        title.style.height = `${title.scrollHeight}px`;
      }
    });
  });
}

function checkTitleOverflowAndSetMinHeight(containerSelector, tileSelector, titleSelector) {
  const containers = document.querySelectorAll(containerSelector);
  containers.forEach(container => {
    const tiles = Array.from(container.querySelectorAll(tileSelector));

    tiles.forEach(tile => {
      tile.classList.remove('tile--content-wrap');
      tile.style.minHeight = '';
    });

    const rows = [];
    tiles.forEach(tile => {
      const top = tile.offsetTop;
      let row = rows.find(r => Math.abs(r.top - top) < 5);
      if (!row) {
        row = { top, tiles: [] };
        rows.push(row);
      }
      row.tiles.push(tile);
    });

    rows.forEach(row => {
      let rowHasOverflow = false;
      let maxHeight = 0;

      row.tiles.forEach(tile => {
        const title = tile.querySelector(titleSelector);
        const lineHeight = parseFloat(getComputedStyle(title).lineHeight);
        const lineCount = Math.round(title.scrollHeight / lineHeight);
        const contentHeight = tile.scrollHeight;

        if (lineCount > 2) {
          title.classList.add('tile--truncate-2-lines');
        }

        if (lineCount > 1) rowHasOverflow = true;
        maxHeight = Math.max(maxHeight, contentHeight);
      });

      row.tiles.forEach(tile => {
        if (rowHasOverflow) {
          tile.classList.add('tile--content-wrap');
          tile.style.minHeight = `${maxHeight}px`;
        }
      });
    });
  });
}

window.applyTruncationToTitles = applyTruncationToTitles;
window.checkTitleOverflowAndSetMinHeight = checkTitleOverflowAndSetMinHeight;
